// redux/reducers/articalModalReducer.js
const initialState = {
    isModalVisible: false,
  };
  
  const articleModalReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SHOW_ADD_ARTICLE_MODAL":
        return { ...state, isModalVisible: true };
  
      case "HIDE_ADD_ARTICLE_MODAL":
        return { ...state, isModalVisible: false };
  
      default:
        return state;
    }
  };
  
  export default articleModalReducer;
  